import { render, staticRenderFns } from "./ios-safari-overlap.vue?vue&type=template&id=fd7d6afe&scoped=true"
import script from "./ios-safari-overlap.vue?vue&type=script&lang=ts"
export * from "./ios-safari-overlap.vue?vue&type=script&lang=ts"
import style0 from "./ios-safari-overlap.vue?vue&type=style&index=0&id=fd7d6afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7d6afe",
  null
  
)

export default component.exports